import type { ReactNode } from 'react';

import { IS_MAC } from '../../../shared/lib/shortcut';
import {
  BookmarksIcon,
  DestinationsIcon,
  EventsIcon,
  FlowsIcon,
  IssuesIcon,
  LibraryIcon,
  SourcesIcon,
  type TIconProps,
} from '../../../shared/ui/icons';

export interface IChord {
  keys: string;
  /** As react-hotkeys-hook reads it: physical keys, so a Cyrillic layout still works. */
  hotkey: string;
}

const chord = (printed: string, code: string): IChord => ({
  keys: `G ${printed}`,
  hotkey: `g>${code}`,
});

export interface INavEntry extends IChord {
  to: string;
  label: string;
  Icon: (props: TIconProps) => ReactNode;
}

export const NAV_ENTRIES: readonly INavEntry[] = [
  { to: '/events', label: 'Events', Icon: EventsIcon, ...chord('E', 'e') },
  { to: '/issues', label: 'Issues', Icon: IssuesIcon, ...chord('I', 'i') },
  { to: '/bookmarks', label: 'Bookmarks', Icon: BookmarksIcon, ...chord('B', 'b') },
  { to: '/flows', label: 'Flows', Icon: FlowsIcon, ...chord('F', 'f') },
  { to: '/sources', label: 'Sources', Icon: SourcesIcon, ...chord('S', 's') },
  { to: '/destinations', label: 'Destinations', Icon: DestinationsIcon, ...chord('D', 'd') },
  { to: '/library', label: 'Library', Icon: LibraryIcon, ...chord('L', 'l') },
];

export const SHELL_CHORDS = {
  search: { keys: IS_MAC ? '⌘K' : 'Ctrl K', hotkey: 'mod+k' },
  notifications: chord('N', 'n'),
  settings: chord(',', 'comma'),
  organizations: chord('O', 'o'),
  account: chord('A', 'a'),
  shortcuts: { keys: '?', hotkey: 'shift+slash' },
  sidebar: { keys: IS_MAC ? '⌘\\' : 'Ctrl \\', hotkey: 'mod+backslash' },
} satisfies Record<string, IChord>;

// 10px inset each side: the 40px square in the 60 rail, the icon at one x in both widths.
export const RAIL_ITEM =
  'relative mx-inset flex h-rail-item shrink-0 items-center gap-3 overflow-hidden whitespace-nowrap rounded-panel px-inset text-left text-body text-faint outline-none hover:text-primary focus-visible:ring-3 focus-visible:ring-focus data-[state=open]:bg-rail-on data-[state=open]:text-primary';

export const RAIL_ITEM_ACTIVE = 'bg-rail-on text-primary';
